function stableTraitPayload(traits: Record<string, unknown>): string {
	const sorted = Object.keys(traits)
		.sort()
		.reduce<Record<string, unknown>>((acc, key) => {
			acc[key] = traits[key];
			return acc;
		}, {});
	return JSON.stringify(sorted);
}

function fnv1aHex(input: string): string {
	let hash = 0x811c9dc5;
	for (let index = 0; index < input.length; index += 1) {
		hash ^= input.charCodeAt(index);
		hash = Math.imul(hash, 0x01000193);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
}

export function hashPosthogTraitsForSession(
	traits: Record<string, unknown>,
): string {
	return fnv1aHex(stableTraitPayload(traits));
}
